import { isExperimentOpen as skylabIsExperimentOpen } from '@wix/skylab'

// FOR TESTING ONLY: add your experiment here to force it open while developing.
// This list must stay empty on master — do NOT merge your additions.
export const FORCE_OPEN_EXPERIMENTS: Array<string> = []

export const isExperimentOpen = (experimentsObj: Record<string, any>, experimentName: string) =>
	FORCE_OPEN_EXPERIMENTS.includes(experimentName) || skylabIsExperimentOpen(experimentsObj, experimentName)
